import { render } from "./ProjectCard.vue?vue&type=template&id=ab55fd10&ts=true"
import script from "./ProjectCard.vue?vue&type=script&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__